import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const ProfileHeader = () => {
  return (
    <div className="w-full border-b border-gray-300 dark:border-gray-800 pb-8 mb-12 px-4 md:px-8 xl:px-24 2xl:px-32">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-8">
        {/* Profile Photo */}
        <div className="flex-shrink-0">
          <img
            src="https://ca.slack-edge.com/T08BD0GSABH-U08BLTF3BT8-dc2d3fbf1411-512"
            alt="David Livingston"
            className="w-32 h-32 lg:w-40 lg:h-40 rounded-full object-cover border-2 border-gray-300 dark:border-gray-700"
          />
        </div>

        {/* Name, Mission, and Social Icons */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
          <h1 className="text-4xl tracking-tight text-black dark:text-gray-200 sm:text-5xl">
            David Livingston
          </h1>
          <p className="mt-4 max-w-md text-base leading-normal text-gray-600 dark:text-gray-400">
            I enjoy engineering systems that solve complex problems for people.
          </p>

          {/* Social Media Links */}
          <ul className="mt-6 flex items-center gap-5" aria-label="Social media">
            <li className="text-xs">
              <a
                className="block hover:text-black dark:hover:text-gray-200 text-gray-600 dark:text-gray-400 transition-colors"
                href="https://github.com/daviddl9"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="GitHub (opens in a new tab)"
              >
                <Github className="h-6 w-6" />
              </a>
            </li>
            <li className="text-xs">
              <a
                className="block hover:text-black dark:hover:text-gray-200 text-gray-600 dark:text-gray-400 transition-colors"
                href="https://sg.linkedin.com/in/d-david-livingston-b10737138"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="LinkedIn (opens in a new tab)"
              >
                <Linkedin className="h-6 w-6" />
              </a>
            </li>
            <li className="text-xs">
              <a
                className="block hover:text-black dark:hover:text-gray-200 text-gray-600 dark:text-gray-400 transition-colors"
                href="mailto:ddl.tdh@gmail.com"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Email (opens in a new tab)"
              >
                <Mail className="h-6 w-6" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
